import { render, staticRenderFns } from "./IntegratorDatabaseConnectionConfigUpsert.vue?vue&type=template&id=855d0d98"
import script from "./IntegratorDatabaseConnectionConfigUpsert.vue?vue&type=script&lang=ts"
export * from "./IntegratorDatabaseConnectionConfigUpsert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports